<template>
  <v-form ref="form" v-model="isUserFormValid">
    <v-row justify="center" style="display: none">
      <v-dialog v-model="computedDialog" persistent max-width="512">
        <v-card>
          <v-card-title class="headline">
            {{
            $i18n.t('settings.users.currentUserSettings', { name: user.email })
            }}
          </v-card-title>
          <v-card-text>
            <v-row justify="center" class="mb-3">
              <user-avatar-settings
                ref="userAvatarSettings"
                :url.sync="user.image_path"
                :user-id="user.id"
              />
            </v-row>
            <v-row>
              <v-col cols="6" class="py-0">
                <v-text-field
                  outlined
                  v-model="user.name"
                  :label="$i18n.t('settings.users.userName')"
                />
              </v-col>
              <v-col cols="6" class="py-0">
                <v-text-field
                  outlined
                  v-model="user.description"
                  :label="$i18n.t('settings.users.userPosition')"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6" class="py-0">
                <v-text-field
                  outlined
                  v-model="user.phone_number"
                  :label="$i18n.t('settings.users.userPhoneNumber')"
                />
              </v-col>
              <v-col cols="6" class="py-0">
                <v-text-field
                  readonly
                  outlined
                  v-model="user.email"
                  :label="$i18n.t('settings.users.userEmail')"
                  :rules="[rules.required]"
                />
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <div class="flex-grow-1" />
            <v-btn
              color="primary"
              text
              @click="cancel"
              :disabled="isUserFormLoading"
            >{{ $i18n.t('default.cancel') }}</v-btn>
            <v-btn
              color="primary"
              text
              @click="save"
              :disabled="!isUserFormValid"
              :loading="isUserFormLoading"
            >{{ $i18n.t('default.save') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-form>
</template>
<script>
import UserAvatarSettings from '@/components/settings/UserAvatarSettings';
export default {
  components: {
    UserAvatarSettings
  },
  props: {
    dialog: {
      required: true,
      type: Boolean
    },
    user: {
      required: true,
      type: Object
    }
  },
  data: () => ({
    isUserFormLoading: false,
    isUserFormValid: false
  }),
  computed: {
    currentUser() {
      return this.$store.getters.getCurrentUser;
    },
    computedDialog: {
      get() {
        return this.dialog;
      },
      set(nV) {
        this.$emit('update:dialog', nV);
      }
    },
    rules() {
      return {
        required: value => !!value || this.$i18n.t('default.requiredField')
      };
    }
  },
  methods: {
    cancel() {
      this.$refs.userAvatarSettings.clearFiles();
      this.$emit('cancel');
    },
    save() {
      this.isUserFormLoading = true;
      let formData = new FormData();
      Object.keys(this.user)
        .filter(key => !['id', 'image_path'].includes(key))
        .forEach(attribute => formData.append(attribute, this.user[attribute]));

      const file = this.$refs.userAvatarSettings.$data.files[0];
      if (file) {
        formData.append('file', file.file);
      } else if (!this.user.image_path) {
        this.$store.dispatch('deleteUserAvatar', this.user.id);
      }
      this.$store.dispatch('editUser', { id: this.user.id, formData }).then(r => {
        if (r.status === 200 || r.status === 201) {
          this.$root.$emit('showSnackbar', this.$i18n.t('settings.users.editSucc'));
          this.computedDialog = false;
          this.$refs.userAvatarSettings.clearFiles();
          this.$root.$emit(`refreshAvatar${this.user.id}`);
          if (this.currentUser.id == this.user.id) {
            this.$root.$emit('refreshCurrentUserAvatar');
          }
        } else if (r.status === 403) {
          this.$root.$emit('showSnackbar', this.$i18n.t('default.accessDenied'));
        } else if (r.status >= 400) {
          this.$root.$emit('showSnackbar', this.$i18n.t('settings.users.editError'));
        }
      });
      this.isUserFormLoading = false;
    }
  }
};
</script>
